import { classifyPaymentTerms } from "@shared/payment-terms";
import { calculatePaymentDueDate } from "@shared/payment-due-date";

export type SupplierTermsResolution = {
  paymentTermCode?: string;
  paymentPayer?: "branch" | "finance";
  paymentResponsibleUserId?: string | null;
  paymentSetupConfirmedAt?: string | null;
  paymentSetupRevision?: number;
  paymentTerms: string;
  paymentTermsLabel: string;
  paymentMethod: "cash" | "credit" | null;
  source: "branch_exception" | "supplier_default";
  sourceLabel: string;
  supplierName: string;
  locationName: string;
  creditLimit: string | null;
  currentOutstanding: string;
};

export function dueDateForTerms(receiptDate: string, terms: string) {
  return calculatePaymentDueDate(receiptDate, terms) || "";
}

export function resolutionText(resolution: SupplierTermsResolution) {
  const source = resolution.source === "branch_exception" ? "branch exception" : "supplier default";
  return resolution.source === "branch_exception"
    ? `${resolution.supplierName} · ${resolution.locationName} — ${resolution.paymentTermsLabel} (${source})`
    : `${resolution.supplierName} — ${resolution.paymentTermsLabel} (${source})`;
}

export function isTermsPaymentCaptureReady(
  resolution: SupplierTermsResolution | undefined,
  loading: boolean,
  failed: boolean,
  method: string,
  recordedTerms = "",
  dueDate = "",
) {
  return !!resolution &&
    !loading &&
    !failed &&
    !!method &&
    (
      method === "cash"
        ? classifyPaymentTerms(recordedTerms) === "cash"
        : method === "credit" && classifyPaymentTerms(recordedTerms) === "credit" && !!dueDate
    );
}
